/*
 * @Descripttion: 项目详情页面特殊处理
 * @Date: 2025-05-26 14:32:56
 */
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import appStore from '@/store';
import { useProjectDetailStore } from '@/views/project-center-edit/src/store/index';
import { useProjectManageStore } from '@/views/project-center/src/store/index';

export const useProject = () => {
  const route = useRoute();
  const { menus } = storeToRefs(appStore.useMenuStoreSetup);
  const { defaultUserFnCode } = storeToRefs(appStore.useUserStoreSetup);

  /**
   * 是否为工业
   */
  const isIndustry = computed(() => defaultUserFnCode.value === 1);
  const isAsp = computed(() => defaultUserFnCode.value === 2);

  // 项目中心缓存数据
  const projectManageStore = useProjectManageStore();
  // 项目中心-项目详情缓存数据
  const projectDetailStore = useProjectDetailStore();
  const projectInfo = computed(() => projectDetailStore?.baseData?.projectInfo);
  const projectMenus = computed(
    () =>
      menus.value.find(
        item => item.url === '/main/project-center-detail/hide'
      ) || { menuList: [] }
  );

  const isProjectDetail = computed(() => {
    return [
      `/main/form-add-list-project`,
      '/main/asp/task-mgmt-list/quick-list',
      ...projectMenus.value?.menuList?.map?.(item => item.url)
    ]
      .filter(Boolean)
      .includes(route.path);
  });
  /**
   * @description: 项目中心、项目详情，菜单处理隐藏逻辑
   * @returns {*}
   */
  const projectHideMenu = () => {
    const editStatus = projectInfo.value?.editStatus;
    const auditStatus = projectInfo.value?.auditStatus;

    if (isIndustry.value) return editStatus !== 4;
    if (isAsp.value) return editStatus !== 4 || auditStatus !== 4;
  };

  /**
   * @description: 清除项目中心搜索缓存数据
   * @returns {*}
   */
  const clearProjectManageStore = async () => {
    if (!isProjectDetail.value) {
      if (projectManageStore?.routeQuery) projectManageStore.clearStore();
      if (projectDetailStore?.baseData) projectDetailStore.clearStore();
    }
  };

  return {
    isProjectDetail,
    projectInfo,
    clearProjectManageStore,
    projectHideMenu
  };
};
